export default function DataHandling() {
  const rows = [
    ["What we collect", "Only the fields you submit: name, work email, organisation, organisation type, and your message or self-check answers. Nothing more."],
    ["Why we collect it", "Solely to respond to your enquiry, manage a register-interest, or generate and follow up on your indicative self-check result."],
    ["Consent", "Every form requires an explicit, unbundled consent checkbox before submission. You are never opted in by default."],
    ["Retention", "Submissions are kept for up to 24 months to manage the engagement, then deleted."],
    ["No third-party analytics", "We run no third-party advertising or analytics trackers on our forms. Your submission is not profiled."],
    ["No selling, no AI training", "Your data is never sold, rented, or used to train AI models."],
    ["Access & deletion", "You can request a copy of, or deletion of, your data at any time by emailing bigtek@bigibila.com.au."],
    ["Sovereignty", "Where submissions relate to Indigenous data or knowledge, Nation authority and project-specific cultural permissions remain with their rightful custodians. We claim no authority over them."],
  ];

  return (
    <div className="mx-auto max-w-4xl px-5 py-14 lg:px-8 lg:py-20">
      <div className="text-xs uppercase tracking-widest-xs text-[hsl(var(--brand))]">Data handling & consent</div>
      <h1 className="mt-4 font-display text-4xl font-bold tracking-tight sm:text-5xl">
        A data-sovereignty company shouldn't run sloppy forms.
      </h1>
      <p className="mt-6 text-lg leading-relaxed text-muted-foreground">
        This is a plain-language statement of exactly what we store, why, and for how long. It applies to
        every enquiry, interest registration and self-check on this site.
      </p>

      <div className="mt-12 border border-border">
        {rows.map(([k, v], i) => (
          <div
            key={k}
            className={`grid gap-2 p-6 sm:grid-cols-[220px_1fr] sm:gap-8 lg:p-8 ${i > 0 ? "border-t border-border" : ""}`}
          >
            <div className="font-display text-base font-medium">{k}</div>
            <div className="text-sm leading-relaxed text-muted-foreground">{v}</div>
          </div>
        ))}
      </div>

      <p className="mt-10 text-xs leading-relaxed text-slate-500">
        This statement is provided in good faith and is not legal advice. For formal privacy requests,
        contact bigtek@bigibila.com.au. BIGTEK is the technology arm of Bigibila (bigibila.com.au).
      </p>
    </div>
  );
}
